// @ts-ignore
import { useUserContext } from "../../Contexts/UserProvider.tsx";
// @ts-ignore
import useApi from "./ServiceClient.tsx";
import { config } from "./config";

export const usePartnerManagement = () => {
  const { GET, POST, DELETE } = useApi(); // Use API methods inside a React hook
  const { tenant } = useUserContext();

  const getPartners = (queryParam) => {
    const response = GET(
      `${config?.intivation_management?.END_POINTS?.GET_INVITES_BY_TENANT}/${tenant?.id}?${queryParam}=true`
    );
    return response;
  };

  return {
    getPartners,
  };
};
